module.exports = __webpack_public_path__ + "static/media/drones.3a6bdce7.jpg";